<template>
  <form class="flex items-start" @submit.prevent="submit">
    <div class="flex-1">
      <input
        v-model="form.code"
        type="text"
        placeholder="Gutschein-Code oder DAS DA-Card"
        class="form-input"
        :class="{ error }"
      >
      <div v-if="error" class="form-error">
        {{ error }}
      </div>
    </div>
    <button :class="color" class="button ml-4" type="submit">
      Anwenden
    </button>
  </form>
</template>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3';
import { computed } from '@vue/reactivity';
import { watchEffect } from 'vue';

const form = useForm({
  code: null,
});

const disabled = computed(() => !form.code);

const color = computed(() => disabled.value
  ? 'bg-gray-400 text-gray-700 cursor-default'
  : ''
);

const error = computed(() =>
  form.errors.code ?? form.errors.exception
);

watchEffect(() => {
  if (disabled.value)
    reset();
});

function reset() {
  form.clearErrors();
  form.reset();
}

function submit() {
  form.post(route('cart.apply-voucher'), {
    preserveScroll: true,
    onSuccess: reset,
  });
}

</script>
